import { createFeatureSelector, createSelector } from '@ngrx/store';
import { memoize } from 'lodash';
import { GenesysCloudExternalContactsState } from '../genesys-cloud-external-contacts.state';
import { featureKey } from '../reducers/feature-key';
import { externalContactAdapter } from '../adapters/external-contact.adapter';

const { selectEntities } = externalContactAdapter.getSelectors();

const selectState = createFeatureSelector<GenesysCloudExternalContactsState>(featureKey);
const selectContactEntities = createSelector(selectState, selectEntities);
export const selectContactById = memoize((id: string) => createSelector(
  selectContactEntities,
  entities => entities[id]
));
export const selectContactFullNameById = memoize((id: string) => createSelector(
  selectContactById(id),
  contact => [contact?.firstName, contact?.middleName, contact?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim())
);
